import React from "react";
import { Grid, Icon, Segment, Header, Label, Message } from "semantic-ui-react";
import "./AcademicInfoTab.scss";

export function AcademicInfoTab({ userData }) {
  return (
    <Segment padded className="academic-info-tab">
      <Header as="h3" dividing>
        <Header.Content>Información del Estudiante</Header.Content>
      </Header>

      {userData ? (
        <Grid stackable>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Segment>
                <Label attached="top" className="academic-info-tab__label">
                  ID de Estudiante
                </Label>
                <p className="academic-info-tab__data">
                  {userData.studentId
                    ? `#${userData.studentId}`
                    : "No asignado"}
                </p>
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment>
                <Label attached="top" className="academic-info-tab__label">
                  Estado de la cuenta
                </Label>
                <p className="academic-info-tab__data">
                  <Icon
                    name={userData.active ? "check circle" : "times circle"}
                    color={userData.active ? "green" : "red"}
                  />
                  {userData.active ? "Activa" : "Inactiva"}
                </p>
              </Segment>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Message icon className="academic-info-tab__message">
                <Icon name="info circle" className="academic-info-tab__icon" />
                <Message.Content>
                  <Message.Header>Información adicional</Message.Header>
                  <p>
                    Para consultar tus calificaciones, progreso académico o
                    realizar pagos, utiliza las secciones correspondientes en el
                    menú de navegación.
                  </p>
                </Message.Content>
              </Message>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : (
        <p>No se encontró información académica.</p>
      )}
    </Segment>
  );
}
